<template>
  <div class="subscription-plans-view-container">
    <headerbar/>
    <div class="go-back" @click="$router.go(-1)"><i class="fa fa-chevron-left"/></div>
    <router-view/>
  </div>
</template>

<script>
import Headerbar from '@/components/Headerbar.vue'
export default {
  name: 'SubscriptionPlansView',
  components: {
    Headerbar,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>